import React from "react";
import PropTypes from "prop-types";
import { customTabType, routeType } from "custom-prop-types";
import styles from "components/documents/custom-tab.scss";
import { DocumentsInlineTabs } from "components/documents/documents-inline-tabs";
import { CustomTabFilters } from "components/documents/custom-tab-filters";
import { ActiveFilters } from "components/documents/filters/active-filters";

export const CustomTab = (props) => (
  <div className={ styles.container }>
    <DocumentsInlineTabs
      accountSlug={ props.accountSlug }
      currentPage={ props.route.path }
      customTabs={ props.customTabs }
      onStartDeleteCustomTabMode={ props.onStartDeleteCustomTabMode }
    />
    <div className={ styles["filters-container"] }>
      <CustomTabFilters { ...props } isExports={ false } />
      <div className={ styles.active }>
        <h3>Your custom filters:</h3>
        <ActiveFilters
          { ...props }
          isExports={ false }
          searchQueryString={ props.selectedSearchQueryString }
          selectedDocumentType={ props.type }
        />
      </div>
    </div>
  </div>
);

CustomTab.propTypes = {
  accountSlug: PropTypes.string.isRequired,
  customTabs: PropTypes.arrayOf(customTabType),
  onStartDeleteCustomTabMode: PropTypes.func.isRequired,
  route: routeType.isRequired,
  selectedSearchQueryString: PropTypes.string,
  type: PropTypes.string
};

CustomTab.defaultProps = {
  customTabs: [],
  selectedSearchQueryString: null,
  type: null
};



// WEBPACK FOOTER //
// ./src/js/components/documents/custom-tab.jsx